import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MaterialModule} from './material.module';
import {CustomButtonComponent} from './components/custom-button/custom-button.component';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {RouterModule} from "@angular/router";
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { ModifyScopeDialogComponent } from './components/modify-scope-dialog/modify-scope-dialog.component';
import { CancelTaskChoiceDialogComponent } from './components/cancel-task-choice-dialog/cancel-task-choice-dialog.component';
import { DeactivationDecisionDialogComponent } from './components/deactivation-decision-dialog/deactivation-decision-dialog.component';
import { MoveToGroupDialogComponent } from './components/move-to-group-dialog/move-to-group-dialog.component';
import { PhoneNumberInputComponent } from './components/phone-number-input/phone-number-input.component';
import { NotificationItemComponent } from './components/notification-item/notification-item.component';
import { HelpPanelComponent } from './components/help-panel/help-panel.component';
import { HelpButtonComponent } from './components/help-button/help-button.component';
import { ContactUsButtonComponent } from './components/contact-us-button/contact-us-button.component';
import { ContactUsDialogComponent } from './components/contact-us-dialog/contact-us-dialog.component';
import { ExecutionEnforcementDialogComponent } from './components/execution-enforcement-dialog/execution-enforcement-dialog.component';
import { DeactivateSchoolDialogComponent } from './components/deactivate-school-dialog/deactivate-school-dialog.component';

@NgModule({
  declarations: [CustomButtonComponent, ConfirmDialogComponent, ModifyScopeDialogComponent, CancelTaskChoiceDialogComponent, DeactivationDecisionDialogComponent, MoveToGroupDialogComponent, PhoneNumberInputComponent, NotificationItemComponent, HelpPanelComponent, HelpButtonComponent, ContactUsButtonComponent, ContactUsDialogComponent, ExecutionEnforcementDialogComponent, DeactivateSchoolDialogComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MaterialModule,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    CustomButtonComponent,
    ConfirmDialogComponent,
    ModifyScopeDialogComponent,
    PhoneNumberInputComponent,
    NotificationItemComponent,
    HelpButtonComponent,
    ContactUsButtonComponent,
    MaterialModule,
  ],
})
export class SharedModule {}
